<template>
  <div v-show="isNoAffiliateModalVisible">
    <div class="modal-mask" @click="closeModal">
      <div class="modal-container visible" @click.stop>
        <div class="modal-header">
          <h6 class="modal-title">No Pricing set for the account</h6>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding-left: 15px;">
              Pricing is not set for the account, please contact administrator
            </div>
          </div>
          <div class="row p-0" style="margin-top: 30px;">
            <div class="col-6 p-0"></div>
            <div class="col-6 p-0 text-right">
              <button type="submit" class="btn btn-sm ma-white-btn" @click="closeModal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'isNoAffiliateModalVisible',
  ],
  data() {
    return {
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}

.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

.modal-body {
  margin: 0px;
  padding: 10px;
}

.modal-header .sub-heading {
  background-color: #FFF;
}

.modal-header {
  padding: 5px;
}

.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}

.modal-title {
  font-size: 14px;
  font-weight: 900;
}

.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}

.modal-body {
  padding: 5px;
}

.ma-blue-btn {
  color: #FFF !important;
  border-radius: 10px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 150px;
}

.ma-white-btn {
  color: #00acee !important;
  border-radius: 10px;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 110px;
}

@media (min-width: 320px) and (max-width: 991px) {
  .modal-container {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manager/no_affiliate_modal.vue